module.exports = __webpack_public_path__ + "img/GE.8374b1d0.svg";